import axios from 'axios';

import User from '../interfaces/user';

const client = axios.create({
  baseURL: '/next-api/active-campaign',
});

const ActiveCampaignAPIService = () => ({
  updateList: async (user: User) =>
    client
      .post('', { user })
      .then(({ data }) => data)
      .catch((error) => ({ error: error?.toJSON() })),
});

export default ActiveCampaignAPIService;
